import React from 'react';
import { motion } from 'framer-motion';
const guides = [{
  name: 'Tomo 01 — Protocolos de Tratamientos',
  value: '$9.990'
}, {
  name: 'Tomo 02 — Presupuestos y Precios',
  value: '$8.990'
}, {
  name: 'Tomo 03 — Contratos y Consentimientos',
  value: '$7.990'
}, {
  name: 'Tomo 04 — Marketing para Esteticistas',
  value: '$9.990'
}, {
  name: 'Tomo 05 — Gestión de Turnos y Clientes',
  value: '$8.990'
}, {
  name: 'Tomo 06 — Productos y Cosmética',
  value: '$9.990'
}];
const bonuses = [{
  name: 'Bono 01 — Kit de Consulta y Diagnóstico',
  value: '$5.990'
}, {
  name: 'Bono 02 — Sistema de Checklists Operativos',
  value: '$4.990'
}, {
  name: 'Bono 03 — Marketing Digital (30 ideas + 12 plantillas WhatsApp)',
  value: '$6.990'
}, {
  name: 'Bono 04 — Calculadora de Rentabilidad + 8 Paquetes listos',
  value: '$5.990'
}, {
  name: 'Bono 05 — Cosmética Avanzada y Combinación de Activos',
  value: '$5.990'
}, {
  name: 'Bono 06 — Sistema de Fidelización y Fotografía Profesional',
  value: '$5.990'
}];
export function ValueStackSection() {
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-196">
      <div className="max-w-3xl mx-auto" data-id="element-197">
        <div className="text-center mb-16" data-id="element-198">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-5xl font-serif font-bold text-brand-purple mb-4" data-id="element-199">
            Todo lo que recibís (y lo que vale cada parte)
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg text-gray-500 font-sans" data-id="element-200">
            Si compraras cada componente por separado, pagarías:
          </motion.p>
        </div>

        <div className="bg-brand-white rounded-3xl p-8 md:p-12 shadow-xl border border-brand-purple/10" data-id="element-201">
          {/* Guides List */}
          <div className="space-y-4 mb-10" data-id="element-202">
            {guides.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} className="flex justify-between items-center border-b border-gray-100 pb-4 last:border-0" data-id="element-203">
                <span className="text-brand-purple font-sans font-medium pr-4" data-id="element-204">
                  {item.name}
                </span>
                <span className="text-gray-400 line-through shrink-0" data-id="element-205">
                  {item.value}
                </span>
              </motion.div>)}
          </div>

          {/* Separator */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center py-6 border-y border-brand-gold/30 mb-10" data-id="element-206">
            <span className="text-brand-gold font-bold tracking-widest text-sm uppercase" data-id="element-207">
              MÁS 6 HERRAMIENTAS EXCLUSIVAS:
            </span>
          </motion.div>

          {/* Bonuses List */}
          <div className="space-y-4 mb-12" data-id="element-208">
            {bonuses.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} className="flex justify-between items-center border-b border-gray-100 pb-4 last:border-0" data-id="element-209">
                <span className="text-brand-purple font-sans font-medium pr-4" data-id="element-210">
                  {item.name}
                </span>
                <span className="text-gray-400 line-through shrink-0" data-id="element-211">
                  {item.value}
                </span>
              </motion.div>)}
          </div>

          {/* Total & CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-center pt-8 border-t-2 border-brand-purple/10" data-id="element-212">
            <p className="text-xl text-gray-400 line-through mb-2" data-id="element-213">
              Valor total: $91.880
            </p>
            <p className="text-4xl md:text-5xl font-sans font-bold text-brand-purple mb-4" data-id="element-214">
              Tu inversión hoy: $19.990 ARS
            </p>
            <p className="text-brand-gold font-medium text-sm mb-8" data-id="element-215">
              Precio de lanzamiento — puede subir en cualquier momento
            </p>

            <a href="https://gana-con-conocimiento.myshopify.com/cart/52148248248603:1" className="inline-block w-full md:w-auto px-10 py-5 bg-brand-gold text-brand-white text-lg font-bold rounded-full hover:bg-brand-gold/90 transition-all duration-300 shadow-lg hover:shadow-brand-gold/30 hover:-translate-y-1" data-id="element-216">
              Quiero el Megapack — $19.990
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}